// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"f2a60f56","453":"d1fc8d31","455":"50d9a2d2"}[chunkId] + ".chunk.js";
};